module.exports = __webpack_public_path__ + "img/go.1977680c.svg";